import gql from 'graphql-tag';

import { FULL_ANSWER_FRAGMENT } from '../Answer/fullAnswer';
import { FAQ_NOTIFICATION_FRAGMENT } from '../Notification/faqNotification';
import { PLEX_QUESTION_TEMPLATE_DETAILS_FRAGMENT } from '../PlexQuestionTemplate/plexQuestionTemplateDetails';
import { FULL_PLEX_USER_RELATION_FRAGMENT } from '../PlexUserRelation/fullPlexUserRelation';

export const QUESTION_DETAILS_FRAGMENT = gql`
  fragment questionDetails on Question {
    id
    text
    status
    type
    plex {
      id
      name
      color
      currentUserRelation {
        ...fullPlexUserRelation
      }
    }
    acceptedAnswer {
      ...fullAnswer
    }
    answersCount
    answers {
      ...fullAnswer
    }
    currentUserRelation
    deleted
    createdAt
    publishChangedAt
    author {
      id
      name
      email
      picture
      jobTitle
    }
    commentsCount
    comments {
      id
      deleted
    }
    reactionCounts {
      type
      count
    }
    currentUserReactions
    labels {
      id
      name
    }
    notification {
      ...faqNotification
    }
    watching
    boardId
    positionInBoard {
      id
      positionInBoard
    }
    source {
      __typename
      ... on GoogleDocumentSource {
        url
      }
    }
    permalink
  }

  ${FULL_ANSWER_FRAGMENT}
  ${PLEX_QUESTION_TEMPLATE_DETAILS_FRAGMENT}
  ${FULL_PLEX_USER_RELATION_FRAGMENT}
  ${FAQ_NOTIFICATION_FRAGMENT}
`;
